import "./terms.css";
import { useState, useEffect } from "react";
import SEOTags from "../../utils/SEOTags";
import Spinner from "../../components/Spinner/Spinner";
import Layout from "../../components/layout/Layout";
import { termsClient } from "../../utils/sanity";
import { PortableText } from "@portabletext/react";
import { formatDate } from "../../utils/formatDate";

const BreadcrumbListSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      item: { "@id": "https://www.vakansa.se/", name: "Hem" },
    },
    {
      "@type": "ListItem",
      position: 2,
      item: {
        "@id": `https://www.vakansa.se/anvandarvillkor`,
        name: "Användarvillkor och Personuppgiftspolicy",
      },
    },
  ],
};

function Terms() {
  const [termsData, setTermsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    termsClient
      .fetch(
        `
      *[_type == "terms"][0] {
      title,
      content,
      updatedAt,
    }
    `,
      )
      .then((data) => {
        setTermsData(data);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, []);

  if (loading)
    return (
      <div className="terms-page-spinner-wrapper">
        <Spinner />
      </div>
    );
  if (error) return <p>Error loading terms data</p>;

  return (
    <div className="terms-outer">
      <SEOTags
        title={"Användarvillkor"}
        description={
          "Dessa användarvillkor reglerar användningen av Tjänsterna (“Tjänsterna”, se vidare p.3) som tillhandahålls av Vakansa AB."
        }
        canonicalUrl={"/anvandarvillkor"}
        ogImage={"/images/logo/meta-logo.jpg"}
        structuredData={BreadcrumbListSchema}
      />
      <Layout>
        <div className="terms-page">
          <span className="terms-date">
            Uppdaterad: {formatDate(termsData.updatedAt)}
          </span>
          <h1 className="terms-header">{termsData.title}</h1>
          <PortableText value={termsData.content} />
        </div>
      </Layout>
    </div>
  );
}

export default Terms;
